var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import useAppComponents from '@/hooks/useAppComponents';
export default function SearchRecommendKeyword({ onPressKeyword: onClickSearch, }) {
    const { api } = useAppComponents();
    const { data } = useQuery({
        queryKey: ['ListSearchPlacePresets'],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { var _a, _b; return (_b = (_a = (yield api.listSearchPlacePresetsPost({}))) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.keywordPresets; }),
    });
    if (!(data === null || data === void 0 ? void 0 : data.length)) {
        return null;
    }
    return (_jsxs(View, { style: { gap: 12 }, children: [_jsx(TitleText, { children: "\uCD94\uCC9C \uD0A4\uC6CC\uB4DC" }), _jsx(ItemList, { children: data === null || data === void 0 ? void 0 : data.map(({ id, searchText, description }) => (_jsx(TouchableItemBox, { elementName: "search_recommend_keyword_item", logParams: { search_text: searchText }, onPress: () => onClickSearch(searchText), children: _jsx(ItemText, { numberOfLines: 1, children: description }) }, id))) })] }));
}
export const ItemList = styled.View({
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
});
export const TitleText = styled.Text({
    fontSize: 14,
    fontFamily: font.pretendardBold,
    color: '#121a27',
});
export const TouchableItemBox = styled(SccTouchableOpacity)({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#f3f4fa',
    borderRadius: 100,
    padding: '7px 12px',
    backgroundColor: '#f3f4fa',
    height: 36,
});
export const ItemText = styled.Text({
    fontSize: 15,
    fontFamily: font.pretendardRegular,
    color: color.black,
});
